/** Layout compacto compartido entre PDF (jsPDF) e impresión HTML. Objetivo: ≥50 ítems por página A4. */
export const PRINT_MARGIN_MM = 10;

export const ITEMS_TABLE = {
  bodyFontSize: 6,
  headFontSize: 6,
  cellPadding: { top: 1, right: 2, bottom: 1, left: 2 },
  minCellHeight: 3.8,
};

/** Anchos de columna en mm (suma = 190 mm útiles en A4 con márgenes de 10 mm). */
export const PDF_COL_WIDTHS_5 = {
  description: 96,
  unit: 12,
  quantity: 18,
  unitPrice: 20,
  subtotal: 44,
};

export const PDF_COL_WIDTHS_6 = {
  description: 66,
  unit: 12,
  project: 28,
  quantity: 18,
  unitPrice: 20,
  subtotal: 46,
};
